import styled from "@emotion/styled";

export const ChatWidgetContainer = styled.div<{ $embedded?: boolean }>`
  width: 100%;
  box-sizing: border-box;
  min-height: ${(p) => (p.$embedded ? "auto" : "100vh")};
  max-height: ${(p) => (p.$embedded ? "auto" : "100vh")};
  overflow: auto;
  background-color: ${(p) => p.theme.colors.background};
  @supports (height: 100dvh) {
    min-height: ${(p) => (p.$embedded ? "auto" : "100dvh")};
    max-height: ${(p) => (p.$embedded ? "auto" : "100dvh")};
  }

  &[aria-disabled="true"] {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const ChatWidgetContainerStack = styled(ChatWidgetContainer)`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
`;

export const ChatWidgetRendererContainer = styled.div`
  width: 100%;
  overflow: visible;

  &[aria-disabled="true"] {
    pointer-events: none;
    opacity: 0.5;
  }
`;
